<template>
  <div class="LyBubble" :class="[isChild ? 'lyItem' : '', sizeClass]" :dir="bubbleMessage.direction ?? 'ltr'">
    <div class="T1" :class="directionClass" :dir="bubbleMessage.direction ?? 'ltr'">
      <div
        class="t1Header"
        :style="{ backgroundColor: bubbleMessage.styles?.header?.backgroundColor }"
        v-if="bubbleMessage.header"
      >
        <FlexMessageComponents
          :direction="bubbleMessage.direction"
          :type="bubbleMessage.header.type"
          :component="bubbleMessage.header"
          :parentLayout="bubbleMessage.header.layout"
          :parentSpacing="bubbleMessage.header.spacing"
          :parentPath="bubbleIndex + '.header.'"
          :hoverPath="hoverPath"
          :editPath="editPath"
          :isAdmin="isAdmin"
          @onSelectNode="selectNode"
          @initListNode="initListNode"
        />
      </div>
      <div
        class="MdSep"
        :style="`border-color: ${bubbleMessage.styles?.hero?.separatorColor} !important`"
        v-if="bubbleMessage.hero && bubbleMessage.header && bubbleMessage.styles?.hero?.separator"
      ></div>
      <div
        class="t1Hero"
        :style="{ backgroundColor: bubbleMessage.styles?.hero?.backgroundColor }"
        v-if="bubbleMessage.hero"
      >
        <FlexMessageComponents
          :direction="bubbleMessage.direction"
          :type="bubbleMessage.hero.type"
          :component="bubbleMessage.hero"
          :parentLayout="bubbleMessage.hero.type === 'box' ? bubbleMessage.hero.layout : ''"
          :parentSpacing="bubbleMessage.hero.type === 'box' ? bubbleMessage.hero.spacing : ''"
          :parentPath="bubbleIndex + '.hero.'"
          :hoverPath="hoverPath"
          :editPath="editPath"
          :isAdmin="isAdmin"
          @onSelectNode="selectNode"
          @initListNode="initListNode"
        />
      </div>
      <div
        class="MdSep"
        :style="`border-color: ${bubbleMessage.styles?.body?.separatorColor} !important`"
        v-if="bubbleMessage.body && (bubbleMessage.hero || bubbleMessage.header) && bubbleMessage.styles?.body?.separator"
      ></div>
      <div
        class="t1Body"
        :class="bubbleMessage.footer ? 'ExHasFooter' : ''"
        :style="{ backgroundColor: bubbleMessage.styles?.body?.backgroundColor }"
        v-if="bubbleMessage.body"
      >
        <FlexMessageComponents
          :direction="bubbleMessage.direction"
          :type="bubbleMessage.body.type"
          :component="bubbleMessage.body"
          :parentLayout="bubbleMessage.body.layout"
          :parentSpacing="bubbleMessage.body.spacing"
          :parentPath="bubbleIndex + '.body.'"
          :hoverPath="hoverPath"
          :editPath="editPath"
          :isAdmin="isAdmin"
          @onSelectNode="selectNode"
          @initListNode="initListNode"
        />
      </div>
      <div
        class="MdSep"
        :style="`border-color: ${bubbleMessage.styles?.footer?.separatorColor} !important`"
        v-if="bubbleMessage.footer && (bubbleMessage.body || bubbleMessage.hero || bubbleMessage.header) && bubbleMessage.styles?.footer?.separator"
      ></div>
      <div
        class="t1Footer"
        v-if="bubbleMessage.footer"
        :style="{ backgroundColor: bubbleMessage.styles?.footer?.backgroundColor }"
      >
        <FlexMessageComponents
          :direction="bubbleMessage.direction"
          :type="bubbleMessage.footer.type"
          :component="bubbleMessage.footer"
          :parentLayout="bubbleMessage.footer.layout"
          :parentSpacing="bubbleMessage.footer.spacing"
          :parentPath="bubbleIndex + '.footer.'"
          :hoverPath="hoverPath"
          :editPath="editPath"
          :isAdmin="isAdmin"
          @onSelectNode="selectNode"
          @initListNode="initListNode"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import FlexMessageComponents from '@/components/common/flex-message/FlexMessageComponents.vue'
import { IFlexMessageBubble } from '@/utils/types'
import FlexMessageTreeNodes from '@/components/common/flex-message/FlexMessageTreeNodes.vue'
import { debounce } from 'quasar'

@Options({
  components: { FlexMessageTreeNodes, FlexMessageComponents },
  directives: { maska },
  emits: ['onSelectNode', 'initListNode'],
})
export default class FlexMessageBubble extends Vue {
  @Prop()
  bubbleMessage!: IFlexMessageBubble

  @Prop()
  isChild!: boolean

  @Prop()
  bubbleIndex!: number

  @Prop()
  hoverPath!: string

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  listNode: string[] = []

  get directionClass() {
    if (this.bubbleMessage.direction === 'rtl') {
      return 'fxRTL'
    }
    return 'fxLTR'
  }

  get sizeClass() {
    if (this.bubbleMessage.size === 'giga') {
      return 'LyGi'
    } else if (this.bubbleMessage.size === 'kilo') {
      return 'LyKi'
    } else if (this.bubbleMessage.size === 'hecto') {
      return 'LyHe'
    } else if (this.bubbleMessage.size === 'deca') {
      return 'LyDe'
    } else if (this.bubbleMessage.size === 'micro') {
      return 'LyMi'
    } else if (this.bubbleMessage.size === 'nano') {
      return 'LyNa'
    }
    return 'LyMe'
  }

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  initListNode(path) {
    this.listNode.push(path)
  }

  private debouncedListNode = debounce(() => {
    this.$emit('initListNode', this.listNode)
  }, 500)

  @Watch('listNode', { deep: true, immediate: true })
  lisNodeChanged() {
    this.debouncedListNode()
  }

  mounted() {
    if (!this.isChild) {
      this.listNode.unshift(this.bubbleIndex + '')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
